import { LobbieDataActionType } from '../../types/lobbieDataReduserType'

export const setUpLobbiesTurns = (n : number) => {
    return {type: LobbieDataActionType.SET_UP_TURNS, payload: n}
}